import { type FC, type PropsWithChildren } from "react";
import { ApolloProvider as ApolloClientProvider } from "@apollo/client";
import { createApolloClient } from "@/shared/utils/apollo";

export const ApolloProvider: FC<PropsWithChildren> = ({ children }) => {
  const client = createApolloClient("partner");

  return (
    <ApolloClientProvider client={client}>{children}</ApolloClientProvider>
  );
};
